
import { money } from "../utils/money";

function normalizeProductImageUrl(value) {
  if (!value) return "";
  const url = String(value).trim();

  if (!url) return "";

  if (url.startsWith("//")) {
    return `https:${url}`;
  }

  return url;
}

function getProductImageSrc(value) {
  const url = normalizeProductImageUrl(value);

  if (!url) return "";

  if (/^https?:\/\//i.test(url)) {
    return `/api/inventory/admin/tvc/image-proxy?url=${encodeURIComponent(url)}`;
  }

  return url;
}

function handleCartImageError(event) {
  event.currentTarget.style.display = "none";

  const fallback = event.currentTarget.parentElement?.querySelector(".cart-image-fallback");

  if (fallback) {
    fallback.style.display = "flex";
  }
}



function ProductVisual({ imageIcon, name }) {
  const value = String(imageIcon || "");

  if (value.startsWith("http")) {
    return (
      <img
        src={value}
        alt={name || "Producto"}
        className="cart-product-img"
        loading="lazy"
                          onError={handleCartImageError}
      />
    );
  }

  return (
    <span className="cart-product-icon">
      {value || "📦"}
    </span>
  );
}

export default function AccountPanels({
  drawerOpen,
  setDrawerOpen,
  lastOrder,
  loadingCart,
  cartItems,
  cartBusy,
  updateQuantity,
  removeItem,
  totals,
  selectedAddressId,
  setSelectedAddressId,
  addresses,
  openAddresses,
  selectedBillingId,
  setSelectedBillingId,
  billingProfiles,
  openBilling,
  checkoutBusy,
  checkout,
  clearCart,
  ordersOpen,
  setOrdersOpen,
  loadingOrders,
  orders,
  cancelBusy,
  cancelOrder,
  addressesOpen,
  setAddressesOpen,
  loadingAddresses,
  addressForm,
  setAddressForm,
  saveAddress,
  addressBusy,
  billingOpen,
  setBillingOpen,
  loadingBilling,
  billingForm,
  setBillingForm,
  saveBilling,
  billingBusy,
  selectedProduct,
  setSelectedProduct,
  addToCart
}) {
  return (
    <>
      {drawerOpen && (
        <div
          className="overlay"
          onClick={() => setDrawerOpen(false)}
        >
          <aside
            className="cart-drawer"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="drawer-header">
              <h2>Tu carrito</h2>

              <button onClick={() => setDrawerOpen(false)}>
                ×
              </button>
            </div>

            {lastOrder && (
              <div className="order-success">
                <strong>Orden creada</strong>
                <p>{lastOrder.order_number}</p>
              </div>
            )}

            {loadingCart ? (
              <div className="empty-cart">
                Cargando...
              </div>
            ) : cartItems.length === 0 ? (
              <div className="empty-cart">
                Carrito vacío
              </div>
            ) : (
              <>
                <div className="cart-items">
                  {cartItems.map((item) => (
                    <div
                      className="cart-item"
                      key={item.cart_item_id}
                    >
                      <div className="cart-image">
                        <ProductVisual imageIcon={item.image_icon} name={item.name} />
                      </div>

                      <div className="cart-info">
                        <strong>{item.name}</strong>

                        <span>{money(item.price)}</span>

                        <small>
                          Disponible: {item.available}
                        </small>

                        <div className="qty-control">
                          <button
                            disabled={cartBusy}
                            onClick={() =>
                              updateQuantity(
                                item.cart_item_id,
                                item.quantity - 1
                              )
                            }
                          >
                            -
                          </button>

                          <span>{item.quantity}</span>

                          <button
                            disabled={cartBusy || item.quantity >= item.available}
                            onClick={() =>
                              updateQuantity(
                                item.cart_item_id,
                                item.quantity + 1
                              )
                            }
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <button
                        className="remove"
                        disabled={cartBusy}
                        onClick={() => removeItem(item.cart_item_id)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>

                <div className="summary">
                  <div>
                    <span>Subtotal</span>
                    <strong>{money(totals.subtotal)}</strong>
                  </div>

                  <div>
                    <span>Envío</span>
                    <strong>{money(totals.shipping)}</strong>
                  </div>

                  <div className="summary-total">
                    <span>Total</span>
                    <strong>{money(totals.total)}</strong>
                  </div>
                </div>

                <div className="checkout-options">
                  <h3>Datos para checkout</h3>

                  <label>
                    Dirección de envío
                    <select
                      value={selectedAddressId}
                      onChange={(event) => setSelectedAddressId(event.target.value)}
                    >
                      <option value="">Seleccionar dirección</option>
                      {addresses.map((address) => (
                        <option
                          key={address.id}
                          value={address.id}
                        >
                          {address.address_name || address.address_type} - {address.street}, {address.city}
                        </option>
                      ))}
                    </select>
                  </label>

                  <button
                    type="button"
                    className="continue-button"
                    onClick={openAddresses}
                  >
                    Administrar direcciones
                  </button>

                  <label>
                    Datos fiscales
                    <select
                      value={selectedBillingId}
                      onChange={(event) => setSelectedBillingId(event.target.value)}
                    >
                      <option value="">No facturar / consumidor final</option>
                      {billingProfiles.map((profile) => (
                        <option
                          key={profile.id}
                          value={profile.id}
                        >
                          {profile.business_name} - {profile.tax_id}
                        </option>
                      ))}
                    </select>
                  </label>

                  <button
                    type="button"
                    className="continue-button"
                    onClick={openBilling}
                  >
                    Administrar datos fiscales
                  </button>
                </div>

                <button type="button"
                  className="checkout-button"
                  disabled={checkoutBusy}
                  onClick={checkout}
                >
                  {checkoutBusy ? "Generando orden..." : "Finalizar compra"}
                </button>

                <button
                  className="continue-button"
                  disabled={cartBusy}
                  onClick={clearCart}
                >
                  Vaciar carrito
                </button>
              </>
            )}
          </aside>
        </div>
      )}

      {ordersOpen && (
        <div
          className="overlay"
          onClick={() => setOrdersOpen(false)}
        >
          <aside
            className="cart-drawer"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="drawer-header">
              <div>
                <span className="eyebrow">Cliente</span>
                <h2>Mis pedidos</h2>
              </div>

              <button
                type="button"
                onClick={() => setOrdersOpen(false)}
              >
                ×
              </button>
            </div>

            {loadingOrders ? (
              <div className="empty-cart">
                Cargando pedidos...
              </div>
            ) : orders.length === 0 ? (
              <div className="empty-cart">
                No tienes pedidos todavía.
              </div>
            ) : (
              <div className="cart-items">
                {orders.map((order) => (
                  <div
                    className="cart-item order-card"
                    key={order.id}
                  >
                    <div className="cart-image">
                      📦
                    </div>

                    <div className="cart-info">
                      <strong>{order.order_number}</strong>
                      <span>{money(order.total)}</span>
                      <p className="brand">Estado: {order.status}</p>
                      <p className="brand">Fecha: {order.created_at}</p>

                      {order.status === "created" && (
                        <button
                          type="button"
                          className="cancel-order-button"
                          disabled={cancelBusy}
                          onMouseDown={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                          }}
                          onClickCapture={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            console.log("Cancelar pedido click", order);
                            cancelOrder(order);
                          }}
                        >
                          {cancelBusy ? "Cancelando..." : "Cancelar pedido"}
                        </button>
                      )}

                      {order.status === "cancelled" && (
                        <p className="cancelled-label">
                          Pedido cancelado
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </aside>
        </div>
      )}

      {addressesOpen && (
        <div
          className="overlay"
          onClick={() => setAddressesOpen(false)}
        >
          <aside
            className="cart-drawer"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="drawer-header">
              <div>
                <span className="eyebrow">Mi cuenta</span>
                <h2>Mis direcciones</h2>
              </div>

              <button
                type="button"
                onClick={() => setAddressesOpen(false)}
              >
                ×
              </button>
            </div>

            {loadingAddresses ? (
              <div className="empty-cart">Cargando direcciones...</div>
            ) : addresses.length === 0 ? (
              <div className="empty-cart">No tienes direcciones guardadas.</div>
            ) : (
              <div className="cart-items">
                {addresses.map((address) => (
                  <div className="cart-item order-card" key={address.id}>
                    <div className="cart-image">📍</div>
                    <div className="cart-info">
                      <strong>{address.address_name || "Dirección"}</strong>
                      <span>{address.full_name}</span>
                      <p className="brand">{address.street} {address.exterior_number || ""}</p>
                      <p className="brand">{address.neighborhood || ""} {address.city}, {address.state}</p>
                      <p className="brand">CP {address.postal_code} · {address.country}</p>
                      {address.is_default && <p className="cancelled-label">Predeterminada</p>}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <form className="account-form" onSubmit={saveAddress}>
              <h3>Agregar dirección</h3>

              <select
                value={addressForm.address_type}
                onChange={(event) => setAddressForm({ ...addressForm, address_type: event.target.value })}
              >
                <option value="shipping">Envío</option>
                <option value="billing">Facturación</option>
              </select>

              <input
                type="text"
                placeholder="Nombre de la dirección: Casa, Oficina, Bodega"
                value={addressForm.address_name}
                onChange={(event) => setAddressForm({ ...addressForm, address_name: event.target.value })}
              />

              <input
                type="text"
                placeholder="Nombre completo"
                value={addressForm.full_name}
                onChange={(event) => setAddressForm({ ...addressForm, full_name: event.target.value })}
              />

              <input
                type="text"
                placeholder="Teléfono"
                value={addressForm.phone}
                onChange={(event) => setAddressForm({ ...addressForm, phone: event.target.value })}
              />

              <input
                type="text"
                placeholder="Calle"
                value={addressForm.street}
                onChange={(event) => setAddressForm({ ...addressForm, street: event.target.value })}
              />

              <input
                type="text"
                placeholder="Número exterior"
                value={addressForm.exterior_number}
                onChange={(event) => setAddressForm({ ...addressForm, exterior_number: event.target.value })}
              />

              <input
                type="text"
                placeholder="Número interior"
                value={addressForm.interior_number}
                onChange={(event) => setAddressForm({ ...addressForm, interior_number: event.target.value })}
              />

              <input
                type="text"
                placeholder="Colonia"
                value={addressForm.neighborhood}
                onChange={(event) => setAddressForm({ ...addressForm, neighborhood: event.target.value })}
              />

              <input
                type="text"
                placeholder="Ciudad / Municipio"
                value={addressForm.city}
                onChange={(event) => setAddressForm({ ...addressForm, city: event.target.value })}
              />

              <input
                type="text"
                placeholder="Estado"
                value={addressForm.state}
                onChange={(event) => setAddressForm({ ...addressForm, state: event.target.value })}
              />

              <input
                type="text"
                placeholder="Código postal"
                value={addressForm.postal_code}
                onChange={(event) => setAddressForm({ ...addressForm, postal_code: event.target.value })}
              />

              <input
                type="text"
                placeholder="País"
                value={addressForm.country}
                onChange={(event) => setAddressForm({ ...addressForm, country: event.target.value })}
              />

              <textarea
                placeholder="Referencias"
                value={addressForm.address_references}
                onChange={(event) => setAddressForm({ ...addressForm, address_references: event.target.value })}
              />

              <button type="submit" disabled={addressBusy}>
                {addressBusy ? "Guardando..." : "Guardar dirección"}
              </button>
            </form>
          </aside>
        </div>
      )}

      {billingOpen && (
        <div
          className="overlay"
          onClick={() => setBillingOpen(false)}
        >
          <aside
            className="cart-drawer"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="drawer-header">
              <div>
                <span className="eyebrow">Mi cuenta</span>
                <h2>Mis datos fiscales</h2>
              </div>

              <button
                type="button"
                onClick={() => setBillingOpen(false)}
              >
                ×
              </button>
            </div>

            {loadingBilling ? (
              <div className="empty-cart">Cargando datos fiscales...</div>
            ) : billingProfiles.length === 0 ? (
              <div className="empty-cart">No tienes datos fiscales guardados.</div>
            ) : (
              <div className="cart-items">
                {billingProfiles.map((profile) => (
                  <div className="cart-item order-card" key={profile.id}>
                    <div className="cart-image">🧾</div>
                    <div className="cart-info">
                      <strong>{profile.business_name}</strong>
                      <span>RFC: {profile.tax_id}</span>
                      <p className="brand">Régimen: {profile.tax_regime || "No especificado"}</p>
                      <p className="brand">Uso CFDI: {profile.cfdi_use || "No especificado"}</p>
                      <p className="brand">Correo: {profile.email || "No especificado"}</p>
                      {profile.is_default && <p className="cancelled-label">Predeterminado</p>}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <form className="account-form" onSubmit={saveBilling}>
              <h3>Agregar datos fiscales</h3>

              <input
                type="text"
                placeholder="Razón social"
                value={billingForm.business_name}
                onChange={(event) => setBillingForm({ ...billingForm, business_name: event.target.value })}
              />

              <input
                type="text"
                placeholder="RFC"
                value={billingForm.tax_id}
                onChange={(event) => setBillingForm({ ...billingForm, tax_id: event.target.value.toUpperCase() })}
              />

              <input
                type="text"
                placeholder="Régimen fiscal, ejemplo: 601"
                value={billingForm.tax_regime}
                onChange={(event) => setBillingForm({ ...billingForm, tax_regime: event.target.value })}
              />

              <input
                type="text"
                placeholder="Uso CFDI, ejemplo: G03"
                value={billingForm.cfdi_use}
                onChange={(event) => setBillingForm({ ...billingForm, cfdi_use: event.target.value.toUpperCase() })}
              />

              <input
                type="email"
                placeholder="Correo de facturación"
                value={billingForm.email}
                onChange={(event) => setBillingForm({ ...billingForm, email: event.target.value })}
              />

              <input
                type="text"
                placeholder="Calle fiscal"
                value={billingForm.street}
                onChange={(event) => setBillingForm({ ...billingForm, street: event.target.value })}
              />

              <input
                type="text"
                placeholder="Número exterior"
                value={billingForm.exterior_number}
                onChange={(event) => setBillingForm({ ...billingForm, exterior_number: event.target.value })}
              />

              <input
                type="text"
                placeholder="Número interior"
                value={billingForm.interior_number}
                onChange={(event) => setBillingForm({ ...billingForm, interior_number: event.target.value })}
              />

              <input
                type="text"
                placeholder="Colonia"
                value={billingForm.neighborhood}
                onChange={(event) => setBillingForm({ ...billingForm, neighborhood: event.target.value })}
              />

              <input
                type="text"
                placeholder="Ciudad / Municipio"
                value={billingForm.city}
                onChange={(event) => setBillingForm({ ...billingForm, city: event.target.value })}
              />

              <input
                type="text"
                placeholder="Estado"
                value={billingForm.state}
                onChange={(event) => setBillingForm({ ...billingForm, state: event.target.value })}
              />

              <input
                type="text"
                placeholder="Código postal"
                value={billingForm.postal_code}
                onChange={(event) => setBillingForm({ ...billingForm, postal_code: event.target.value })}
              />

              <button type="submit" disabled={billingBusy}>
                {billingBusy ? "Guardando..." : "Guardar datos fiscales"}
              </button>
            </form>
          </aside>
        </div>
      )}

      {selectedProduct && (
        <div
          className="overlay"
          onClick={() => setSelectedProduct(null)}
        >
          <section
            className="product-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className="modal-close"
              onClick={() => setSelectedProduct(null)}
            >
              ×
            </button>

            <div className="modal-image">
              <ProductVisual imageIcon={selectedProduct.image_icon} name={selectedProduct.name} />
            </div>

            <div>
              <span className="badge">
                {selectedProduct.available > 0 ? selectedProduct.badge || "Disponible" : "Sin inventario"}
              </span>

              <h2>{selectedProduct.name}</h2>

              <p className="brand">{selectedProduct.brand}</p>

              <p className="modal-description">
                {selectedProduct.description}
              </p>

              <div className="price-row large">
                <strong>{money(selectedProduct.price)}</strong>
              </div>

              <p className="stock">
                Disponible: {selectedProduct.available}
              </p>

              <button
                className="modal-add"
                disabled={cartBusy || selectedProduct.available <= 0}
                onClick={() => {
                  addToCart(selectedProduct);
                  setSelectedProduct(null);
                }}
              >
                {selectedProduct.available <= 0 ? "Sin inventario" : "Agregar al carrito"}
              </button>
            </div>
          </section>
        </div>
      )}
    </>
  );
}
